


import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="mask0_9399_20930" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_9399_20930)">
      <path d="M9.99626 9.99813C10.4546 9.99813 10.847 9.83493 11.1733 9.50854C11.4997 9.18216 11.6629 8.78979 11.6629 8.33146C11.6629 7.87313 11.4997 7.48077 11.1733 7.15438C10.847 6.82799 10.4546 6.66479 9.99626 6.66479C9.53792 6.66479 9.14556 6.82799 8.81917 7.15438C8.49278 7.48077 8.32959 7.87313 8.32959 8.33146C8.32959 8.78979 8.49278 9.18216 8.81917 9.50854C9.14556 9.83493 9.53792 9.99813 9.99626 9.99813ZM9.99626 16.1231C11.6907 14.5676 12.9476 13.1544 13.7671 11.8835C14.5865 10.6127 14.9963 9.48424 14.9963 8.49813C14.9963 6.98424 14.5136 5.74466 13.5483 4.77938C12.5831 3.8141 11.399 3.33146 9.99626 3.33146C8.59348 3.33146 7.40945 3.8141 6.44417 4.77938C5.4789 5.74466 4.99626 6.98424 4.99626 8.49813C4.99626 9.48424 5.40598 10.6127 6.22542 11.8835C7.04487 13.1544 8.30181 14.5676 9.99626 16.1231ZM9.99626 18.3315C7.76014 16.4287 6.09001 14.6613 4.98584 13.0294C3.88167 11.3974 3.32959 9.88702 3.32959 8.49813C3.32959 6.41479 3.99973 4.75507 5.34001 3.51896C6.68028 2.28285 8.23237 1.66479 9.99626 1.66479C11.7601 1.66479 13.3122 2.28285 14.6525 3.51896C15.9928 4.75507 16.6629 6.41479 16.6629 8.49813C16.6629 9.88702 16.1108 11.3974 15.0067 13.0294C13.9025 14.6613 12.2324 16.4287 9.99626 18.3315Z" className="fill-[#333] dark:fill-white"/>
    </g>
  </svg>
);

export default Icon;
